<template>
  <div style="max-height: 400px;">
    <div style="height: 10px"></div>
    <el-form size="small" :model="phoneForm" :rules="phoneRules" ref="phoneForm" label-width="80px" class="demo-ruleForm">
      <el-row>
        <el-col :span="14">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="phoneForm.name"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="phone">
            <el-input v-model="phoneForm.phone"></el-input>
          </el-form-item>
          <el-form-item label="短号">
            <el-input v-model="phoneForm.im_num"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <div style="width: 90px;margin: auto">
            <el-upload
              class="avatar-uploader"
              action="#"
              :auto-upload="false"
              :show-file-list="false"
              :on-exceed="handleExceed"
              :before-upload="beforeUpload"
              :on-change="getFile"
              list-type="picture">
              <img v-if="photourl" :src="photourl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div style="font-size: 16px;text-align: center;color: #409EFF">
            <span v-if="addEditPhoneObj.isAdd">上传头像</span>
            <span v-else>更新头像</span>
          </div>
          <div style="font-size: 14px;text-align: center;color: #999999"><span>jpeg/jpg/png格式，且不超过300KB</span></div>
        </el-col>
      </el-row>
    </el-form>
    <div class="dialog-footer" style="text-align: right;padding: 10px 20px 20px 0">
      <el-button @click="closeOpen()">取 消</el-button>
      <el-button type="primary" @click="submitPhone('phoneForm')">确 定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'addEditPhone',
  model: {
    prop: 'addEditPhoneShow',
    event: 'change'
  },
  props: {
    addEditPhoneObj: {
      type: Object
    }
  },
  created () {
    if (this.addEditPhoneObj.isAdd) {
      this.phoneForm.name = ''
      this.phoneForm.phone = ''
      this.phoneForm.im_num = ''
      this.phoneForm.uri = ''
    } else {
      this.phoneForm.no = this.addEditPhoneObj.row.no
      this.phoneForm.name = this.addEditPhoneObj.row.name
      this.phoneForm.phone = this.addEditPhoneObj.row.phone
      this.phoneForm.im_num = this.addEditPhoneObj.row.im_num === '112' ? '' : this.addEditPhoneObj.row.im_num
      let arr = ['.png', '.jpg', '.jpeg']
      for (let i = 0; i < arr.length; i++) {
        if (this.addEditPhoneObj.row.uri.includes(arr[i])) {
          this.phoneForm.uri = this.addEditPhoneObj.row.uri
        }
      }
    }
  },
  data () {
    return {
      phoneForm: {
        no: '',
        phone: '',
        name: '',
        uri: '',
        im_num: ''
      },
      phoneRules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入电话号码', trigger: 'blur' }
        ]
      },
      photourl: ''
    }
  },
  methods: {
    handleExceed (files, fileList) {},
    beforeUpload (file) {},
    getFile (file, fileList) {},
    getBase64 (file) {},
    submitPhone (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit('getFather', this.phoneForm)
          this.$emit('change', false)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    closeOpen () {
      this.$emit('change', false)
    }
  }
}
</script>

<style scoped>

</style>
<style>
  /*上传图片*/
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 90px!important;
    height: 90px!important;
    line-height: 90px!important;
    text-align: center!important;
  }
  .avatar {
    width: 90px;
    height: 90px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/systemlog/childComponents/addEditPhone.vue